import { useState } from "react"
import styled, { css } from "styled-components"

import { ApiTypes } from "types"
import { ReactComponent as RightIcon } from "assets/svg/icon-right.svg"

import styles from "./index.module.scss"

const AccordionHeader = styled.div<{ isImmediate?: boolean }>`
  ${({ isImmediate }) =>
    isImmediate &&
    css`
      cursor: default;
      pointer-events: none;
    `}
`

interface Props {
  isImmediate?: boolean
  devices: ApiTypes.Model.PerformanceTestDevice[]
}

export const PerformanceTestSelectedDevices = ({ devices, isImmediate }: Props) => {
  const [showSelectedDevices, setShowSelectedDevices] = useState(isImmediate || false)

  const handleShowSelectedDevices = () => {
    setShowSelectedDevices(!showSelectedDevices)
  }

  return (
    <div className={styles.selectedDeviceSection}>
      <AccordionHeader
        isImmediate={isImmediate}
        className={`${styles.selectedDevicesHeader} ${showSelectedDevices ? styles.showSelectedDevices : ""}`}
        onClick={handleShowSelectedDevices}
      >
        <p>Selected Device{isImmediate ? "" : `(S) (${devices.length})`}</p>
        {!isImmediate && <RightIcon />}
      </AccordionHeader>
      {showSelectedDevices && (
        <div className={styles.selectedDevicesBody}>
          {devices.map(({ id, email, sn }) => (
            <div key={id} className={styles.selectedDeviceRow}>
              <div className={styles.selectedDeviceRowItem}>
                <p>Email</p>
                <span>{email || "-"}</span>
              </div>
              <div className={styles.selectedDeviceRowItem}>
                <p>Device S/N</p>
                <span>{sn}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
